import { provideTranslocoScope } from '@jsverse/transloco';
import { scopeLoader } from '@core-utils';

export function provideCoreDataScope() {
  return provideTranslocoScope({
    scope: 'coreData',
    loader: scopeLoader(
      (lang: string, root: string) => import(`../${root}/${lang}.json`),
    ),
  });
}
